import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private readonly activeLocaleSignal = signal('nl');
  readonly activeLocale = this.activeLocaleSignal.asReadonly();

  setLocale(locale: string): void {
    this.activeLocaleSignal.set(locale);
  }
}
